<template>
  <form @submit.prevent="addCLI">
    <b-form-group :label="$t('CUSTOMER')" class="style">
      <div class="d-flex align-items-center" style="gap: 8px">
        <multiselect
          v-model="selectedClient"
          :searchable="true"
          :close-on-select="true"
          :multiple="false"
          :options="getAllclients"
          :custom-label="customLabel"
          label="nom"
          track-by="id"
          :placeholder="$t('Select')"
          class="form-input custom-placeholder custom-input"
          style="flex: 1"
        />
        <b-button
          v-if="showAddClientButton"
          size="sm"
          variant="success"
          class="button-succes-style"
          @click.prevent.stop="$emit('add-client')"
        >
          +
        </b-button>
      </div>
    </b-form-group>
    <b-form-group :label="$t('TYPE')+ ' *'">
      <b-form-select
        v-model="clientData.type"
        :options="optionsTypeClient"
        :state="validateState('type')"
        aria-describedby="type-feedback"
        @change="handleTypeChange"
        @input="handleTypeChange"
      ></b-form-select>
      <error-handle
        :list="v$.clientData.type.$errors"
        id="type-feedback"
      ></error-handle>
      <div v-if="erreurlist.type" class="error-message">
        <ul v-if="Array.isArray(erreurlist.type)">
          <span v-for="(e, index) in erreurlist.type" :key="index">
            {{ e }}
          </span>
        </ul>
        <span v-else>{{ erreurlist.type }}</span>
      </div>
    </b-form-group>
 
 
 

  

    <b-form-group
      v-if="isProfessionel"
     
    >
      
   
  

  
      <!-- Messages d'erreur téléphone désactivés -->
      <!-- <div v-if="v$.clientData.tel.$error" class="error-message">
        {{ $t("REQUIRED_FIELD") }}
      </div>
      <div v-if="clientData.tel && resultValid == false" class="error-message">
        {{ $t("ERROR_PHONE") }}
      </div> -->
    </b-form-group>

    <div v-if="!isProfessionel" style="width: 100%">
      <div class="row">
        <div v-if="!isProfessionel" class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('Civilite') + ' 1*'">
            <b-form-select
              v-model="v$.clientData.civilite_1.$model"
              :options="optionsCivilite"
              :state="validateState('civilite_1')"
              aria-describedby="civilite_1-feedback"
              @input="updateClientParent('civilite_1', clientData.civilite_1)"
            ></b-form-select>
            <error-handle
              :list="v$.clientData.civilite_1.$errors"
              id="civilite_1-feedback"
            ></error-handle>
            <div v-if="erreurlist.civilite_1" class="error-message">
              <ul v-if="Array.isArray(erreurlist.civilite_1)">
                <span
                  v-for="(e, index) in erreurlist.civilite_1"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.civilite_1 }}</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('NAME') + '*'">
            <b-form-input
              v-model="v$.clientData.nom.$model"
              oninput="this.value = this.value.toUpperCase()"
              :state="validateState('nom')"
              aria-describedby="nom-feedback"
              @input="updateClientParent('nom', clientData.nom)"
            ></b-form-input>
            <error-handle
              :list="v$.clientData.nom.$errors"
              id="nom-feedback"
            ></error-handle>
            <div v-if="erreurlist.nom" class="error-message">
              <ul v-if="Array.isArray(erreurlist.nom)">
                <span
                  v-for="(e, index) in erreurlist.nom"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.nom }}</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group
            :label="$t('SURNAME') + '*'"
            label-for="lastname"
          >
            <b-form-input
              v-model="v$.clientData.prenom.$model"
              oninput="this.value = this.value.toUpperCase()"
              :state="validateState('prenom')"
              aria-describedby="prenom-feedback"
              @input="updateClientParent('prenom', clientData.prenom)"
            ></b-form-input>
            <error-handle
              :list="v$.clientData.prenom.$errors"
              id="prenom-feedback"
            ></error-handle>
            <div v-if="erreurlist.prenom" class="error-message">
              <ul v-if="Array.isArray(erreurlist.prenom)">
                <span
                  v-for="(e, index) in erreurlist.prenom"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.prenom }}</span>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('Téléphone portable') + '**'" label-for="telephone">
            <template>
              <phone :tel="clientData.tel_mobile || clientData.tel" @phoneNumber="formatNumber($event)"></phone>
            </template>
            <error-handle
              :list="v$.clientData.tel_mobile.phone_number.$errors"
              id="tel_mobile-feedback"
            ></error-handle>
            <!-- Message d'erreur erreurlist téléphone désactivé -->
            <!-- <div v-if="erreurlist.tel_mobile || erreurlist.tel" class="error-message">
              <ul v-if="Array.isArray(erreurlist.tel_mobile || erreurlist.tel)">
                <span
                  v-for="(e, index) in (erreurlist.tel_mobile || erreurlist.tel)"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.tel_mobile || erreurlist.tel }}</span>
            </div> -->
            <!-- Messages d'erreur téléphone désactivés -->
            <!-- <div
              v-if="
                (clientData.tel_mobile || clientData.tel) && resultValid == false
              "
              class="error-message"
            >
              {{ $t("ERROR_PHONE") }}
            </div> -->
          </b-form-group>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('Téléphone fixe') + '**'" label-for="telephone-fixe">
            <template>
              <phone :tel="clientData.tel_fixe" @phoneNumber="formatNumberFixe($event)"></phone>
            </template>
            <error-handle
              :list="v$.clientData.tel_fixe.phone_number.$errors"
              id="tel_fixe-feedback"
            ></error-handle>
            <!-- Message d'erreur erreurlist téléphone fixe désactivé -->
            <!-- <div v-if="erreurlist.tel_fixe" class="error-message">
              <ul v-if="Array.isArray(erreurlist.tel_fixe)">
                <span
                  v-for="(e, index) in erreurlist.tel_fixe"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.tel_fixe }}</span>
            </div> -->
            <!-- Message d'erreur téléphone fixe désactivé -->
            <!-- <div
              v-if="
                clientData.tel_fixe && clientData.tel_fixe.phone_number && resultValidFixe == false
              "
              class="error-message"
            >
              {{ $t("ERROR_PHONE") }}
            </div> -->
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('Fonction')">
            <b-form-input
              v-model="clientData.fonction"
              oninput="this.value = this.value.toUpperCase()"
              @input="updateClientParent('fonction', clientData.fonction)"
            ></b-form-input>
            <div v-if="erreurlist.fonction" class="error-message">
              <ul v-if="Array.isArray(erreurlist.fonction)">
                <span
                  v-for="(e, index) in erreurlist.fonction"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.fonction }}</span>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('Civilite ') + ' 2'">
            <b-form-select
              v-model="clientData.civilite_2"
              :options="optionsCivilite"
              @input="updateClientParent('civilite_2', clientData.civilite_2)"
            ></b-form-select>
            <div v-if="erreurlist.civilite_2" class="error-message">
              <ul v-if="Array.isArray(erreurlist.civilite_2)">
                <span
                  v-for="(e, index) in erreurlist.civilite_2"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.civilite_2 }}</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('NAME') + ' 2'">
            <b-form-input
              v-model="clientData.nom_2"
              oninput="this.value = this.value.toUpperCase()"
              @input="updateClientParent('nom_2', clientData.nom_2)"
            ></b-form-input>
            <div v-if="erreurlist.nom_2" class="error-message">
              <ul v-if="Array.isArray(erreurlist.nom_2)">
                <span
                  v-for="(e, index) in erreurlist.nom_2"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.nom_2 }}</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('SURNAME') + ' 2'">
            <b-form-input
              v-model="clientData.prenom_2"
              oninput="this.value = this.value.toUpperCase()"
              @input="updateClientParent('prenom_2', clientData.prenom_2)"
            ></b-form-input>
            <div v-if="erreurlist.prenom_2" class="error-message">
              <ul v-if="Array.isArray(erreurlist.prenom_2)">
                <span
                  v-for="(e, index) in erreurlist.prenom_2"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.prenom_2 }}</span>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('EMAIL') + '*'" label-for="email">
            <b-form-input
              v-model="v$.clientData.email.$model"
              :state="validateState('email')"
              aria-describedby="email-feedback"
              type="email"
              @input="updateClientParent('email', clientData.email)"
              :disabled="selected"
            ></b-form-input>
            <error-handle
              :list="v$.clientData.email.$errors"
              id="email-feedback"
            ></error-handle>
            <div v-if="erreurlist.email" class="error-message">
              <ul v-if="Array.isArray(erreurlist.email)">
                <span
                  v-for="(e, index) in erreurlist.email"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.email }}</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('EMAIL') + ' 2'" label-for="email2">
            <b-form-input
              v-model="clientData.email_2"
              type="email"
              @input="updateClientParent('email_2', clientData.email_2)"
            ></b-form-input>
            <div v-if="erreurlist.email_2" class="error-message">
              <ul v-if="Array.isArray(erreurlist.email_2)">
                <span
                  v-for="(e, index) in erreurlist.email_2"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.email_2 }}</span>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('STREET') + '*'" label-for="rue">
            <b-form-input
              v-model="v$.clientData.rue.$model"
              :state="validateState('rue')"
              aria-describedby="rue-feedback"
              @input="updateClientParent('rue', clientData.rue)"
            ></b-form-input>
            <error-handle
              :list="v$.clientData.rue.$errors"
              id="rue-feedback"
            ></error-handle>
            <div v-if="erreurlist.rue" class="error-message">
              <ul v-if="Array.isArray(erreurlist.rue)">
                <span
                  v-for="(e, index) in erreurlist.rue"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.rue }}</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t(' Complément d\'adresse')" label-for="complement-adresse">
            <b-form-input
              v-model="clientData.complement_adresse"
              @input="updateClientParent('complement_adresse', clientData.complement_adresse)"
            ></b-form-input>
            <div v-if="erreurlist.complement_adresse" class="error-message">
              <ul v-if="Array.isArray(erreurlist.complement_adresse)">
                <span
                  v-for="(e, index) in erreurlist.complement_adresse"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.complement_adresse }}</span>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group
            :label="$t('POSTAL_CODE') + '*'"
            label-for="cp"
          >
            <b-form-input
              v-model="v$.clientData.cp.$model"
              :state="validateState('cp')"
              aria-describedby="cp-feedback"
              type="number"
              @paste="(event) => onPaste(event, 'clientData.cp')"
              @keydown="(event) => onKeyDown(event)"
              @input="updateClientParent('cp', clientData.cp) && validatePostalCode"
              maxlength="5"
              max="99999"
            ></b-form-input>
            <error-handle
              :list="v$.clientData.cp.$errors"
              id="cp-feedback"
            ></error-handle>
            <div v-if="erreurlist.cp" class="error-message">
              <ul v-if="Array.isArray(erreurlist.cp)">
                <span
                  v-for="(e, index) in erreurlist.cp"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.cp }}</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('CITY') + '*'" label-for="ville">
            <b-form-input
              v-model="v$.clientData.ville.$model"
              :state="validateState('ville')"
              aria-describedby="ville-feedback"
              @keydown="preventNumberInput"
              @input="
                clientData.ville = clientData.ville.replace(/[^a-zA-ZÀ-ÿ\s'-]/g, '') &&
                updateClientParent('ville', clientData.ville)
              "
            ></b-form-input>
            <error-handle
              :list="v$.clientData.ville.$errors"
              id="ville-feedback"
            ></error-handle>
            <div v-if="erreurlist.ville" class="error-message">
              <ul v-if="Array.isArray(erreurlist.ville)">
                <span
                  v-for="(e, index) in erreurlist.ville"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.ville }}</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('COUNTRY') + ''">
            <multiselect
              v-model="clientData.pays"
              @input="updateClientParent('pays', clientData.pays)"
              :searchable="true"
              :close-on-select="true"
              :multiple="false"
              :options="getAllcountries"
              label="name"
              track-by="id"
            >
              <template slot="noResult">
                {{ $t("NO_DATA_FOUND") }}
              </template>
            </multiselect>
            <div v-if="erreurlist.pays" class="error-message">
              <ul v-if="Array.isArray(erreurlist.pays)">
                <span
                  v-for="(e, index) in erreurlist.pays"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.pays }}</span>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('ZONE') + '*'">
            <b-form-select
              v-model="v$.clientData.zone.$model"
              @input="updateClientParent('zone', clientData.zone)"
              :options="optionsZone"
              text-field="text"
              value-field="value"
              :state="validateState('zone')"
              aria-describedby="zone-feedback"
            >
              <template #first>
                <b-form-select-option :value="null" disabled
                  >-- {{ $t("ZONE") }} --</b-form-select-option
                >
              </template>
            </b-form-select>
            <error-handle
              :list="v$.clientData.zone.$errors"
              id="zone-feedback"
            ></error-handle>
            <div v-if="erreurlist.zone" class="error-message">
              <ul v-if="Array.isArray(erreurlist.zone)">
                <span
                  v-for="(e, index) in erreurlist.zone"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.zone }}</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('PRECARITE')">
            <b-form-select
              v-model="clientData.precarite"
              @input="updateClientParent('precarite', clientData.precarite)"
              :options="optionsprecarite"
              text-field="text"
              value-field="value"
            >
              <template #first>
                <b-form-select-option :value="null" disabled
                  >-- {{ $t("PRECARITE") }} --</b-form-select-option
                >
              </template>
            </b-form-select>
            <div v-if="erreurlist.precarite" class="error-message">
              <ul v-if="Array.isArray(erreurlist.precarite)">
                <span
                  v-for="(e, index) in erreurlist.precarite"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.precarite }}</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('Role') + '*'">
            <b-form-select
              v-model="v$.clientData.type_occupation.$model"
              @input="updateClientParent('type_occupation', clientData.type_occupation)"
              :options="optionsTypeOccupation"
              text-field="text"
              value-field="value"
              :state="validateState('type_occupation')"
              aria-describedby="type_occupation-feedback"
            >
              <template #first>
                <b-form-select-option :value="null" disabled
                  >-- {{ $t("Role") }} --</b-form-select-option
                >
              </template>
            </b-form-select>
            <error-handle
              :list="v$.clientData.type_occupation.$errors"
              id="type_occupation-feedback"
            ></error-handle>
            <div v-if="erreurlist.type_occupation" class="error-message">
              <ul v-if="Array.isArray(erreurlist.type_occupation)">
                <span
                  v-for="(e, index) in erreurlist.type_occupation"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.type_occupation }}</span>
            </div>
          </b-form-group>
        </div>
      </div>
    </div>
    <div v-if="isProfessionel" style="width: 100%">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 my-2 py-0">
          <b-form-group :label="$t('Raison sociale') + '*'">
            <b-form-input
              v-model="v$.clientData.raison_sociale.$model"
              oninput="this.value = this.value.toUpperCase()"
              :state="validateState('raison_sociale')"
              aria-describedby="raison_sociale-feedback"
              @input="updateClientParent('raison_sociale', clientData.raison_sociale)"
            ></b-form-input>
            <error-handle
              :list="v$.clientData.raison_sociale.$errors"
              id="raison_sociale-feedback"
            ></error-handle>
            <div v-if="erreurlist.raison_sociale" class="error-message">
              <ul v-if="Array.isArray(erreurlist.raison_sociale)">
                <span
                  v-for="(e, index) in erreurlist.raison_sociale"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.raison_sociale }}</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('Nom commercial')">
            <b-form-input
              v-model="clientData.nom_commercial"
              oninput="this.value = this.value.toUpperCase()"
              @input="updateClientParent('nom_commercial', clientData.nom_commercial)"
            ></b-form-input>
            <div v-if="erreurlist.nom_commercial" class="error-message">
              <ul v-if="Array.isArray(erreurlist.nom_commercial)">
                <span
                  v-for="(e, index) in erreurlist.nom_commercial"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.nom_commercial }}</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('SIRET') + '*'">
            <b-form-input
              v-model="v$.clientData.siret.$model"
              :state="validateState('siret')"
              aria-describedby="siret-feedback"
              @input="updateClientParent('siret', clientData.siret)"
            ></b-form-input>
            <error-handle
              :list="v$.clientData.siret.$errors"
              id="siret-feedback"
            ></error-handle>
            <div v-if="erreurlist.siret" class="error-message">
              <ul v-if="Array.isArray(erreurlist.siret)">
                <span
                  v-for="(e, index) in erreurlist.siret"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.siret }}</span>
            </div>
          </b-form-group>
        </div>
      </div>
      <h5 class="titresociete my-3">{{ $t("Signataire") }}</h5>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('Civilite')">
            <b-form-select
              v-model="clientData.civilite"
              :options="optionsCivilite"
              @input="updateClientParent('civilite', clientData.civilite)"
            ></b-form-select>
            <div v-if="erreurlist.civilite" class="error-message">
              <ul v-if="Array.isArray(erreurlist.civilite)">
                <span
                  v-for="(e, index) in erreurlist.civilite"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.civilite }}</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('NAME') + '*'">
            <b-form-input
              v-model="v$.clientData.nom.$model"
              oninput="this.value = this.value.toUpperCase()"
              :state="validateState('nom')"
              aria-describedby="nom-pro-feedback"
              @input="updateSignataireNom"
            ></b-form-input>
            <error-handle
              :list="v$.clientData.nom.$errors"
              id="nom-pro-feedback"
            ></error-handle>
            <div v-if="erreurlist.signataire_nom" class="error-message">
              <ul v-if="Array.isArray(erreurlist.signataire_nom)">
                <span
                  v-for="(e, index) in erreurlist.signataire_nom"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.signataire_nom }}</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('SURNAME') + '*'">
            <b-form-input
              v-model="v$.clientData.prenom.$model"
              oninput="this.value = this.value.toUpperCase()"
              :state="validateState('prenom')"
              aria-describedby="prenom-pro-feedback"
              @input="updateSignatairePrenom"
            ></b-form-input>
            <error-handle
              :list="v$.clientData.prenom.$errors"
              id="prenom-pro-feedback"
            ></error-handle>
            <div v-if="erreurlist.signataire_prenom" class="error-message">
              <ul v-if="Array.isArray(erreurlist.signataire_prenom)">
                <span
                  v-for="(e, index) in erreurlist.signataire_prenom"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.signataire_prenom }}</span>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('Fonction')">
          <b-form-input
        v-model="v$.clientData.poste.$model"
        @input="updateClientParent('poste', clientData.poste)"
        oninput="this.value = this.value.toUpperCase()"
        :state="validateState('poste')"
        aria-describedby="poste-feedback"
      ></b-form-input>
         
          </b-form-group>
             <error-handle
        :list="v$.clientData.poste.$errors"
        id="poste-feedback"
      ></error-handle>
        </div>
      </div>
      <h5 class="titresociete mt-3">{{ $t("ADDRESS") }}</h5>
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12 mb-2 py-0">
          <b-form-group :label="$t('STREET') + '*'">
            <b-form-input
              v-model="v$.clientData.rue.$model"
              :state="validateState('rue')"
              aria-describedby="rue-feedback"
              @input="updateClientParent('rue', clientData.rue)"
            ></b-form-input>
            <error-handle
              :list="v$.clientData.rue.$errors"
              id="rue-feedback"
            ></error-handle>
            <div v-if="erreurlist.rue" class="error-message">
              <ul v-if="Array.isArray(erreurlist.rue)">
                <span
                  v-for="(e, index) in erreurlist.rue"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.rue }}</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t(' Complément d\'adresse')">
            <b-form-input
              v-model="clientData.complement_adresse"
              @input="updateClientParent('complement_adresse', clientData.complement_adresse)"
            ></b-form-input>
            <div v-if="erreurlist.complement_adresse" class="error-message">
              <ul v-if="Array.isArray(erreurlist.complement_adresse)">
                <span
                  v-for="(e, index) in erreurlist.complement_adresse"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.complement_adresse }}</span>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('POSTAL_CODE') + '*'">
            <b-form-input
              v-model="v$.clientData.cp.$model"
              :state="validateState('cp')"
              aria-describedby="cp-feedback"
              type="number"
              @paste="(event) => onPaste(event, 'clientData.cp')"
              @keydown="(event) => onKeyDown(event)"
              @input="updateClientParent('cp', clientData.cp) && validatePostalCode"
              maxlength="5"
              max="99999"
            ></b-form-input>
            <error-handle
              :list="v$.clientData.cp.$errors"
              id="cp-feedback"
            ></error-handle>
            <div v-if="erreurlist.cp" class="error-message">
              <ul v-if="Array.isArray(erreurlist.cp)">
                <span
                  v-for="(e, index) in erreurlist.cp"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.cp }}</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('CITY') + '*'">
            <b-form-input
              v-model="v$.clientData.ville.$model"
              :state="validateState('ville')"
              aria-describedby="ville-feedback"
              @keydown="preventNumberInput"
              @input="
                clientData.ville = clientData.ville.replace(/[^a-zA-ZÀ-ÿ\s'-]/g, '') &&
                updateClientParent('ville', clientData.ville)
              "
            ></b-form-input>
            <error-handle
              :list="v$.clientData.ville.$errors"
              id="ville-feedback"
            ></error-handle>
            <div v-if="erreurlist.ville" class="error-message">
              <ul v-if="Array.isArray(erreurlist.ville)">
                <span
                  v-for="(e, index) in erreurlist.ville"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.ville }}</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('COUNTRY') + ''">
            <multiselect
              v-model="clientData.pays"
              @input="updateClientParent('pays', clientData.pays)"
              :searchable="true"
              :close-on-select="true"
              :multiple="false"
              :options="getAllcountries"
              label="name"
              track-by="id"
            >
              <template slot="noResult">
                {{ $t("NO_DATA_FOUND") }}
              </template>
            </multiselect>
            <div v-if="erreurlist.pays" class="error-message">
              <ul v-if="Array.isArray(erreurlist.pays)">
                <span
                  v-for="(e, index) in erreurlist.pays"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.pays }}</span>
            </div>
              </b-form-group>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 py-0">
              <b-form-group :label="$t('Role') + '*'">
                <b-form-select
                  v-model="v$.clientData.type_occupation.$model"
                  @input="updateClientParent('type_occupation', clientData.type_occupation)"
                  :options="optionsTypeOccupation"
                  text-field="text"
                  value-field="value"
                  :state="validateState('type_occupation')"
                  aria-describedby="type_occupation-pro-feedback"
                >
                  <template #first>
                    <b-form-select-option :value="null" disabled
                      >-- {{ $t("Role") }} --</b-form-select-option
                    >
                  </template>
                </b-form-select>
                <error-handle
                  :list="v$.clientData.type_occupation.$errors"
                  id="type_occupation-pro-feedback"
                ></error-handle>
                <div v-if="erreurlist.type_occupation" class="error-message">
                  <ul v-if="Array.isArray(erreurlist.type_occupation)">
                    <span
                      v-for="(e, index) in erreurlist.type_occupation"
                      :key="index"
                    >
                      {{ e }}
                    </span>
                  </ul>
                  <span v-else>{{ erreurlist.type_occupation }}</span>
                </div>
              </b-form-group>
            </div>
          </div>
      <h5 class="titresociete mt-3">{{ $t("Contact ") }}</h5>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('Email') + '*'">
            <b-form-input
              v-model="v$.clientData.email.$model"
              type="email"
              :state="validateState('email')"
              aria-describedby="email-pro-feedback"
              @input="updateClientParent('email', clientData.email)"
            ></b-form-input>
            <error-handle
              :list="v$.clientData.email.$errors"
              id="email-pro-feedback"
            ></error-handle>
            <div v-if="erreurlist.email" class="error-message">
              <ul v-if="Array.isArray(erreurlist.email)">
                <span
                  v-for="(e, index) in erreurlist.email"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.email }}</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('Téléphone portable') + '**'">
            <template>
              <phone :tel="clientData.tel_mobile_pro || clientData.tel" @phoneNumber="formatMobileNumberPro($event)"></phone>
            </template>
            <error-handle
              :list="v$.clientData.tel_mobile_pro.phone_number.$errors"
              id="tel_mobile_pro-feedback"
            ></error-handle>
            <!-- Message d'erreur erreurlist téléphone mobile pro désactivé -->
            <!-- <div v-if="erreurlist.tel_mobile_pro" class="error-message">
              <ul v-if="Array.isArray(erreurlist.tel_mobile_pro)">
                <span
                  v-for="(e, index) in erreurlist.tel_mobile_pro"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.tel_mobile_pro }}</span>
            </div> -->
            <!-- Message d'erreur téléphone mobile pro désactivé -->
            <!-- <div
              v-if="
                (clientData.tel_mobile_pro || clientData.tel) && resultValidMobilePro == false
              "
              class="error-message"
            >
              {{ $t("ERROR_PHONE") }}
            </div> -->
          </b-form-group>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('Téléphone fixe') + '**'">
            <template>
              <phone :tel="clientData.tel_fixe_pro || clientData.company_tel" @phoneNumber="formatFixedNumberPro($event)"></phone>
            </template>
            <error-handle
              :list="v$.clientData.tel_fixe_pro.phone_number.$errors"
              id="tel_fixe_pro-feedback"
            ></error-handle>
            <!-- Message d'erreur erreurlist téléphone fixe pro désactivé -->
            <!-- <div v-if="erreurlist.tel_fixe_pro" class="error-message">
              <ul v-if="Array.isArray(erreurlist.tel_fixe_pro)">
                <span
                  v-for="(e, index) in erreurlist.tel_fixe_pro"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.tel_fixe_pro }}</span>
            </div> -->
            <!-- Message d'erreur téléphone fixe pro désactivé -->
            <!-- <div
              v-if="
                (clientData.tel_fixe_pro || clientData.company_tel) && resultValidFixePro == false
              "
              class="error-message"
            >
              {{ $t("ERROR_PHONE") }}
            </div> -->
          </b-form-group>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-lg-12 col-md-12 col-sm-12 py-0">
          <b-form-group :label="$t('ZONE') + '*'">
            <b-form-select
              v-model="v$.clientData.zone.$model"
              @input="updateClientParent('zone', clientData.zone)"
              :options="optionsZone"
              text-field="text"
              value-field="value"
              :state="validateState('zone')"
              aria-describedby="zone-pro-feedback"
            >
              <template #first>
                <b-form-select-option :value="null" disabled
                  >-- {{ $t("ZONE") }} --</b-form-select-option
                >
              </template>
            </b-form-select>
            <error-handle
              :list="v$.clientData.zone.$errors"
              id="zone-pro-feedback"
            ></error-handle>
            <div v-if="erreurlist.zone" class="error-message">
              <ul v-if="Array.isArray(erreurlist.zone)">
                <span
                  v-for="(e, index) in erreurlist.zone"
                  :key="index"
                >
                  {{ e }}
                </span>
              </ul>
              <span v-else>{{ erreurlist.zone }}</span>
            </div>
          </b-form-group>
        </div>
      </div>

      <!-- Bloc Coordonnées bancaires désactivé dans le step client
      <h5 class="titresociete">{{ $t("COMPANY_BANK") }}</h5>

      <b-form-group :label="$t('ACCOUNT_OWNER')+ ' '">
        <b-form-input
          v-model="v$.clientData.titulaire_compte.$model"
          @input="
            updateClientParent('titulaire_compte', clientData.titulaire_compte)
          "
          :state="validateState('titulaire_compte')"
          aria-describedby="titulaire_compte-feedback"
        ></b-form-input>
        <error-handle
          :list="v$.clientData.titulaire_compte.$errors"
          id="titulaire_compte-feedback"
        ></error-handle>
        <div v-if="erreurlist.titulaire_compte" class="error-message">
          <ul v-if="Array.isArray(erreurlist.titulaire_compte)">
            <span
              v-for="(e, index) in erreurlist.titulaire_compte"
              :key="index"
            >
              {{ e }}
            </span>
          </ul>
          <span v-else>{{ erreurlist.titulaire_compte }}</span>
        </div>
      </b-form-group>

      <b-form-group label="IBAN " label-for="IBAN">
        <b-form-input
          v-model="v$.clientData.IBAN.$model"
          @input="updateClientParent('IBAN', clientData.IBAN)"
          :state="validateState('IBAN')"
          aria-describedby="IBAN-feedback"
        ></b-form-input>
        <error-handle
          :list="v$.clientData.IBAN.$errors"
          id="IBAN-feedback"
        ></error-handle>
        <div v-if="erreurlist.IBAN" class="error-message">
          <ul v-if="Array.isArray(erreurlist.IBAN)">
            <span v-for="(e, index) in erreurlist.IBAN" :key="index">
              {{ e }}
            </span>
          </ul>
          <span v-else>{{ erreurlist.IBAN }}</span>
        </div>
      </b-form-group>

      <b-form-group label="SWIFT_BIC" label-for="SWIFT_BIC">
        <b-form-input
          v-model="v$.clientData.SWIFT_BIC.$model"
          @input="updateClientParent('SWIFT_BIC', clientData.SWIFT_BIC)"
          :state="validateState('SWIFT_BIC')"
          aria-describedby="SWIFT_BIC-feedback"
          oninput="this.value = this.value.toUpperCase()"
        ></b-form-input>
        <error-handle
          :list="v$.clientData.SWIFT_BIC.$errors"
          id="SWIFT_BIC-feedback"
        ></error-handle>
        <div v-if="erreurlist.SWIFT_BIC" class="error-message">
          <ul v-if="Array.isArray(erreurlist.SWIFT_BIC)">
            <span v-for="(e, index) in erreurlist.SWIFT_BIC" :key="index">
              {{ e }}
            </span>
          </ul>
          <span v-else>{{ erreurlist.SWIFT_BIC }}</span>
        </div>
      </b-form-group>
      -->

      <!-- Bloc Forme juridique / APE / NAF / Revenu avis imposition / Commentaire désactivé dans le step client
      <b-form-group :label="$t('forme_juridique')" label-for="forme_juridique">
        <b-form-input
          v-model="v$.clientData.forme_juridique.$model"
          @input="
            updateClientParent('forme_juridique', clientData.forme_juridique)
          "
          :state="validateState('forme_juridique')"
          aria-describedby="forme_juridique-feedback"
        ></b-form-input>
        <error-handle
          :list="v$.clientData.forme_juridique.$errors"
          id="forme_juridique-feedback"
        ></error-handle>
        <div v-if="erreurlist.forme_juridique" class="error-message">
          <ul v-if="Array.isArray(erreurlist.forme_juridique)">
            <span v-for="(e, index) in erreurlist.forme_juridique" :key="index">
              {{ e }}
            </span>
          </ul>
          <span v-else>{{ erreurlist.forme_juridique }}</span>
        </div>
      </b-form-group>
      <b-form-group :label="$t('ape')" label-for="ape">
        <b-form-input
          v-model="v$.clientData.ape.$model"
          @input="updateClientParent('ape', clientData.ape)"
          :state="validateState('ape')"
          aria-describedby="ape-feedback"
        ></b-form-input>
        <error-handle
          :list="v$.clientData.ape.$errors"
          id="ape-feedback"
        ></error-handle>
        <div v-if="erreurlist.ape" class="error-message">
          <ul v-if="Array.isArray(erreurlist.ape)">
            <span v-for="(e, index) in erreurlist.ape" :key="index">
              {{ e }}
            </span>
          </ul>
          <span v-else>{{ erreurlist.ape }}</span>
        </div>
      </b-form-group>
      <b-form-group :label="$t('naf')" label-for="naf">
        <b-form-input
          v-model="v$.clientData.naf.$model"
          @input="updateClientParent('naf', clientData.naf)"
          :state="validateState('naf')"
          aria-describedby="naf-feedback"
        ></b-form-input>
        <error-handle
          :list="v$.clientData.naf.$errors"
          id="ape-feedback"
        ></error-handle>
        <div v-if="erreurlist.naf" class="error-message">
          <ul v-if="Array.isArray(erreurlist.naf)">
            <span v-for="(e, index) in erreurlist.naf" :key="index">
              {{ e }}
            </span>
          </ul>
          <span v-else>{{ erreurlist.naf }}</span>
        </div>
      </b-form-group>
      
      <b-form-group :label="$t('Revenu avis imposition')" label-for="revenu_avis_imposition">
        <b-form-input
          v-model="clientData.revenu_avis_imposition"
          type="number"
          @input="updateClientParent('revenu_avis_imposition', clientData.revenu_avis_imposition)"
        ></b-form-input>
        <div v-if="erreurlist.revenu_avis_imposition" class="error-message">
          <ul v-if="Array.isArray(erreurlist.revenu_avis_imposition)">
            <span v-for="(e, index) in erreurlist.revenu_avis_imposition" :key="index">
              {{ e }}
            </span>
          </ul>
          <span v-else>{{ erreurlist.revenu_avis_imposition }}</span>
        </div>
      </b-form-group>
      
      <hr />
      
      <b-form-group :label="$t('COMMENTAIRE')" label-for="commentaire">
        <b-form-textarea
          v-model="clientData.commentaire"
          @input="updateClientParent('commentaire', clientData.commentaire)"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
        <div v-if="erreurlist.commentaire" class="error-message">
          <ul v-if="Array.isArray(erreurlist.commentaire)">
            <span v-for="(e, index) in erreurlist.commentaire" :key="index">
              {{ e }}
            </span>
          </ul>
          <span v-else>{{ erreurlist.commentaire }}</span>
        </div>
      </b-form-group>
      -->
    </div>

 
  </form>
</template>
<script>
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import phone from "@/components/ui/phone.vue";
import { useVuelidate } from "@vuelidate/core";
import { mapGetters, mapActions } from "vuex";

import {
  required,
  email,
  maxLength,
  minLength,
  requiredIf,
  alphaNum,
  numeric,
} from "@vuelidate/validators";
import {
  preventExceedingLength,
  handlePaste,
  preventExceedingLengthFloat,
} from "@/utils/inputUtils";
import errorHandle from "@/components/ui/errorHandle.vue";
export default {
  props: {
    idLogementData: {
      type: Number,
      required: false,
    },
    showAddClientButton: {
      type: Boolean,
      default: false,
      required: false,
    },
    menageValue: {
      type: Object,
      required: false,
    },
    logementValue: {
      type: Object,
      required: false,
    },
    clientParentData: {
      type: Object,
      required: true,
    },
  },
  components: {
    phone,
    errorHandle,
 

  },
  setup() {
    return { v$: useVuelidate({ $lazy: true, $autoDirty: true }) };
  },
  data() {
    return {
      menageData: null,
      clientData: { ...this.clientParentData },
      erreurlist: {
        nom: null,
        prenom: null,
        email: null,
        rue: null,
        cp: null,
        ville: null,
        tel: null,
        type: null,
        zone: null,
        pays: null,
        SWIFT_BIC: null,
        forme_juridique: null,
        ape: null,
        naf: null,
        IBAN: null,
        titulaire_compte: null,
        commentaire: null,
        company: null,
       
        company_tel: null,
        precarite: null,
        type_chauffage: null,
        type_logement: null,
        // Champs pour les clients particuliers
        civilite_1: null,
        civilite_2: null,
        nom_2: null,
        prenom_2: null,
        email_2: null,
        complement_adresse: null,
        tel_mobile: null,
        tel_fixe: null,
        // Champs pour les clients professionnels
        raison_sociale: "",
        nom_commercial: "",
        siret: "",
        civilite: null,
        signataire_nom: null,
        signataire_prenom: null,
        fonction: null,
       
        tel_mobile_pro: null,
        tel_fixe_pro: null,
      },
      phoneValid: null,
      resultValid: null,
      resultValidFixe: null,
      resultValidMobilePro: null,
      resultValidFixePro: null,
      errorS: null,
      selected: false,
      inputSearchValue: "",
      optionsTypeClient: [
        { value: "type.particulier", text: this.$t("PARTICULAR") },
        { value: "type.professionnel", text: this.$t("PROFESSIONAL") },
        { value: "type.bailleur_sociale", text: "Bailleur sociale" },
        { value: "type.syndic_copropriete_professionnel", text: "Syndic copropriété professionnel" },
        { value: "type.entreprise", text: "Entreprise" },
        { value: "type.etablissement", text: "Établissement" },
        { value: "type.collectivite_territoriale_mairie", text: "Collectivité territoriale / Mairie" },
        { value: "type.organisation_professionnelle", text: "Organisation professionnelle" },
        { value: "type.syndic_copropriete_benevole", text: "Syndic copropriété bénévole" },
      ],
      optionsZone: [
        { value: "h1", text: "H1" },
        { value: "h2", text: "H2" },
        { value: "h3", text: "H3" },
      ],
      optionsprecarite: [
        { value: "Modeste", text: this.$t("Modeste") },
        { value: "Intermédiaires", text: this.$t("Intermédiaires") },
        { value: "tres_modeste", text: this.$t("Tmodeste") },
        { value: "supérieurs", text: this.$t("Supérieurs") },
      ],
      optionsTypeOccupation: [
        { value: "Propriétaire", text: "Propriétaire" },
        { value: "locataire", text: "Locataire" },
        { value: "autre", text: "Autre" },
        { value: "Maître d'ouvrage", text: "Maître d'ouvrage" },
      ],
      optionsCivilite: [
        { value: "Monsieur", text: "Monsieur" },
        { value: "Madame", text: "Madame" },
      ],
      Barememproption: [
        { value: null, text: "Aucun" },
        { value: "blue", text: this.$t("BLEU") },
        { value: "yellow", text: this.$t("YELLOW") },
        { value: "purple", text: this.$t("PURPLE") },
        { value: "pink", text: this.$t("PINK") },
      ],
      search: "",
      disabled: false,
      clientAdd: false,
    };
  },
  watch: {
    inputSearchValue(newValue) {
      if (newValue.trim() === "") {
        this.selected = false;
      }
    },
    clientParentData: {
      deep: true,
      handler(newData) {
        if (newData) {
          // Pour les clients professionnels, s'assurer que l'email est correctement initialisé
          let emailValue = newData.email ?? null;
          if (this.isProfessionel) {
            // Si email existe, l'utiliser
            if (newData.email) {
              emailValue = newData.email;
            }
            // Sinon, utiliser company_email si disponible
            else if (newData.company_email && !emailValue) {
              emailValue = newData.company_email;
            }
          }
          
          // Copier toutes les données, en s'assurant que les champs critiques sont initialisés
          this.clientData = {
            ...newData,
            // S'assurer que les champs texte sont initialisés avec "" au lieu de null/undefined
            raison_sociale: newData.raison_sociale ?? "",
            nom_commercial: newData.nom_commercial ?? "",
            siret: newData.siret ?? "",
            poste: newData.poste ?? "",
            // Pour les particuliers, initialiser fonction depuis poste si disponible
            fonction: newData.fonction ?? (!this.isProfessionel && newData.poste ? newData.poste : null),
            email: emailValue,
           
            // S'assurer que civilite et siret sont bien initialisés et préservent leurs valeurs
            civilite: newData.civilite ?? null,
           
          };
          console.log('=== INITIALISATION EMAIL DANS CLIENT STEP ===', {
            email: this.clientData.email,
            newDataEmail: newData.email,
            newDataCompanyEmail: newData.company_email,
            type: newData.type
          });
          console.log('=== INITIALISATION CLIENT DATA ===', {
            civilite: this.clientData.civilite,
            siret: this.clientData.siret,
            newDataCivilite: newData.civilite,
            newDataSiret: newData.siret
          });
        }
        // Formater les numéros de téléphone après la mise à jour
        this.$nextTick(() => {
          this.formatPhoneNumbersOnMount();
        });
      },
    },
  },
  created() {
    var lang;
    this.clientAdd = this.getdevisMonoFiche.data.devis.client === null;

    switch (this.getSelectedLang.iso_code) {
      case "fr":
        lang = "fr";
        break;
      case "prt":
        lang = "pt";
        break;
      case "IT":
        lang = "it";
        break;
      case "ar":
        lang = "fa";
        break;

      case "Gr":
        lang = "de";
        break;
      default:
        lang = " ";
    }
    this.pays(lang);
    this.all_countries({ page: this.page, perPage: 100000 });

    this.all_clients({
      search: "",
      page: this.page,
      per_page: 100000,
      entreprise_id: this.getdevisMonoFiche.data.devis.entreprise.id,
    });
  },
  computed: {
    ...mapGetters([
      "getdevisType",
      "getPays",
      "getAllcountries",
      "getSelectedLang",
      "getAllcountries",
      "getAllclients",
      "getdevisMonoFiche",
      "getOnlineUser",
    ]),
    isSuperAdmin() {
      return this.getOnlineUser.role == "user.super-admin";
    },
    isProfessionel() {
      if (!this.clientData || !this.clientData.type) return false;
      const professionalTypes = [
        'type.professionnel',
        'type.bailleur_sociale',
        'type.syndic_copropriete_professionnel',
        'type.entreprise',
        'type.etablissement',
        'type.collectivite_territoriale_mairie',
        'type.organisation_professionnelle',
        'type.syndic_copropriete_benevole'
      ];
      return professionalTypes.includes(this.clientData.type);
    },
    selectedClient: {
      get() {
        if (typeof this.clientData === "object" && this.clientData !== null) {
          return this.clientData;
        } else {
          return this.getAllclients.find(
            (option) => option.id === this.clientData
          );
        }
      },
      set(value) {
        if (value) {
          console.log('=== CLIENT SÉLECTIONNÉ ===', value);
          
          // Utiliser les données brutes si disponibles, sinon utiliser l'objet Client
          const rawData = value._rawData || value;
          
          // Copier toutes les données directement depuis la liste
          const updatedData = {
            ...rawData,
            // Formater les numéros de téléphone
            tel: {
              phone_number: rawData.phone?.phone_number || "",
              phone_iso_code: rawData.phone?.iso_code || "",
            },
            company_tel: {
              phone_number: rawData.company_phone?.phone_number || "",
              phone_iso_code: rawData.company_phone?.iso_code || "",
            },
            // S'assurer que tous les champs sont préservés avec leurs valeurs exactes
            precarite: rawData.precarite ?? null,
            type_occupation: rawData.type_occupation ?? null,
            // Champs pour les clients particuliers - préserver les valeurs
            civilite_1: rawData.civilite_1 ?? null,
            civilite_2: rawData.civilite_2 ?? null,
            nom_2: rawData.nom_2 ?? null,
            prenom_2: rawData.prenom_2 ?? null,
            email_2: rawData.email_2 ?? null,
            complement_adresse: rawData.complement_adresse ?? null,
            tel_mobile: rawData.tel_mobile ?? (rawData.phone ? {
              phone_number: rawData.phone.phone_number || null,
              phone_iso_code: rawData.phone.iso_code || null,
            } : null),
            tel_fixe: rawData.tel_fixe ? (typeof rawData.tel_fixe === 'string' ? {
              phone_number: rawData.tel_fixe,
              phone_iso_code: rawData.tel_fixe_phone_iso_code || 'FR',
            } : rawData.tel_fixe) : (rawData.tel_fixe_phone_number ? {
              phone_number: rawData.tel_fixe_phone_number,
              phone_iso_code: rawData.tel_fixe_phone_iso_code || 'FR',
            } : null),
            // Champs pour les clients professionnels - préserver les valeurs
            raison_sociale: rawData.raison_sociale ?? "",
            nom_commercial: rawData.nom_commercial ?? "",
            siret: rawData.siret ?? "",
            civilite: rawData.civilite ?? null,
            signataire_nom: rawData.signataire_nom ?? null,
            signataire_prenom: rawData.signataire_prenom ?? null,
            fonction: rawData.fonction ?? null,
            email: rawData.email ?? null,
           
          
            tel_mobile_pro: rawData.tel_mobile_pro ?? (rawData.phone ? {
              phone_number: rawData.phone.phone_number || null,
              phone_iso_code: rawData.phone.iso_code || null,
            } : null),
            tel_fixe_pro: rawData.tel_fixe_pro ?? (rawData.company_phone ? {
              phone_number: rawData.company_phone.phone_number || null,
              phone_iso_code: rawData.company_phone.iso_code || null,
            } : null),
            // S'assurer que les autres champs sont aussi copiés
            ape: rawData.ape ?? null,
            naf: rawData.naf ?? null,
            forme_juridique: rawData.forme_juridique ?? null,
          };

          for (const [field, fieldValue] of Object.entries(updatedData)) {
            this.updateClientParent(field, fieldValue);
            this.$set(this.clientData, field, fieldValue);
          }
          console.log('=== CLIENT APRÈS TRAITEMENT ===', this.clientData);
          this.$emit('update:logementValue', null);
          this.getdevisMonoFiche.data.devis.logement_id = null;
          this.getdevisMonoFiche.data.devis.logement = {};
          this.selected = true;
        } else {
          const resetData = {
            nom: "",
            prenom: "",
            rue: "",
            cp: "",
            ville: "",
            id: null,
            zone: null,
            precarite: null,
            type_occupation: null,
            type: "type.particulier",
            email: "",
            pays: "",
            phone: "",
            tel: {
              phone_number: "",
              phone_iso_code: "",
            },
            menage: null,
            // Réinitialiser les champs pour les clients particuliers
            civilite_1: null,
            civilite_2: null,
            nom_2: null,
            prenom_2: null,
            email_2: null,
            complement_adresse: null,
            tel_mobile: null,
            tel_fixe: null,
            // Réinitialiser les champs pour les clients professionnels
            raison_sociale: "",
            nom_commercial: "",
            siret: "",
            civilite: null,
            signataire_nom: null,
            signataire_prenom: null,
            fonction: null,
          
            tel_mobile_pro: null,
            tel_fixe_pro: null,
          };
          for (const [field, fieldValue] of Object.entries(resetData)) {
            this.updateClientParent(field, fieldValue);
            this.$set(this.clientData, field, fieldValue);
          }

          this.$emit('update:logementValue', null);
          this.getdevisMonoFiche.data.devis.logement_id = null;
          this.getdevisMonoFiche.data.devis.logement = {};
          this.selected = false;
        }
      },
    },
  },

  validations() {
    return {
      clientData: {
        type: { required },
        // Champs obligatoires pour tous les types
        nom: {
          required,
          maxLength: maxLength(100),
        },
        prenom: {
          required,
          maxLength: maxLength(100),
        },
        email: {
          required,
          email,
          maxLength: maxLength(50),
        },
        rue: {
          required,
          maxLength: maxLength(100),
        },
        cp: {
          required,
          numeric,
          minLength: minLength(4),
          maxLength: maxLength(5),
        },
        ville: {
          required,
          maxLength: maxLength(100),
        },
        zone: {
          required,
        },
        type_occupation: {
          required,
        },
        // Validation téléphone : soit portable OU fixe (l'un des deux obligatoire pour tous)
        tel_mobile: {
          phone_number: {
            requiredIf: requiredIf(() => {
              // Vérifier si tel_fixe n'est pas rempli
              const hasTelFixe = this.clientData.tel_fixe && this.clientData.tel_fixe.phone_number;
              return !hasTelFixe;
            }),
          },
        },
        tel_fixe: {
          phone_number: {
            requiredIf: requiredIf(() => {
              // Vérifier si tel_mobile n'est pas rempli
              const hasTelMobile = this.clientData.tel_mobile && this.clientData.tel_mobile.phone_number;
              return !hasTelMobile;
            }),
          },
        },
        pays: {},
        // Champs obligatoires uniquement pour particulier
        civilite_1: {
          requiredIf: requiredIf(() => !this.isProfessionel),
        },
        // Champs obligatoires uniquement pour professionnel
        raison_sociale: {
          requiredIf: requiredIf(() => this.isProfessionel),
          maxLength: maxLength(100),
        },
        siret: {
          requiredIf: requiredIf(() => this.isProfessionel),
        },
        signataire_nom: {
          maxLength: maxLength(100),
        },
        signataire_prenom: {
          maxLength: maxLength(100),
        },
        company: {
          maxLength: maxLength(100),
        },
        company_email: {
          email,
          maxLength: maxLength(50),
        },
        tel_mobile_pro: {
          phone_number: {
            requiredIf: requiredIf(() => {
              // Seulement pour les professionnels
              if (!this.isProfessionel) return false;
              // Vérifier si tel_fixe_pro n'est pas rempli
              const hasTelFixePro = this.clientData.tel_fixe_pro && this.clientData.tel_fixe_pro.phone_number;
              return !hasTelFixePro;
            }),
          },
        },
        tel_fixe_pro: {
          phone_number: {
            requiredIf: requiredIf(() => {
              // Seulement pour les professionnels
              if (!this.isProfessionel) return false;
              // Vérifier si tel_mobile_pro n'est pas rempli
              const hasTelMobilePro = this.clientData.tel_mobile_pro && this.clientData.tel_mobile_pro.phone_number;
              return !hasTelMobilePro;
            }),
          },
        },
        poste: {
          maxLength: maxLength(40),
        },
        forme_juridique: {},
        ape: {},
        naf: {},
        SWIFT_BIC: {
          minLength: minLength(8),
          maxLength: maxLength(11),
          alphaNum,
        },
        IBAN: { maxLength: maxLength(34), alphaNum },
        titulaire_compte: { maxLength: maxLength(40) },
        // Champs pour compatibilité (anciens champs)
        tel: {
          phone_number: {},
        },
        company_tel: {
          phone_number: {},
        },
      },
    };
  },
  mounted() {
    console.log('Countries data:', this.getAllcountries);
    console.log('Selected country:', this.clientData.pays);
    
    // Formater les numéros de téléphone après le montage
    this.$nextTick(() => {
      this.formatPhoneNumbersOnMount();
    });
  },
  methods: {
    ...mapActions([
      "storeMenage",
      "editMenage",
      "edit_client",
      "all_clients",
      "pays",
      "storeLogement",
      "all_clients",
      "store_clients",
      "client",
      "store_client",
      "all_countries",
      "setDevisMonoFiche",
    ]),
    async validateForm() {
      // Méthode publique pour valider le formulaire depuis le parent
      // Toucher tous les champs pour déclencher la validation
      this.v$.clientData.$touch();
      
      // Fonction helper pour vérifier si un numéro de téléphone est valide (non vide après nettoyage)
      const hasValidPhone = (phoneObj) => {
        if (!phoneObj) return false;
        const phoneNumber = phoneObj.phone_number || phoneObj.number || '';
        if (!phoneNumber) return false;
        
        // Convertir en string et nettoyer
        const phoneStr = phoneNumber.toString().trim();
        if (phoneStr.length === 0) return false;
        
        // Si le numéro contient déjà des chiffres (même avec préfixe), considérer comme valide
        const hasDigits = /\d/.test(phoneStr);
        if (!hasDigits) return false;
        
        // Retirer le préfixe +XX (1 à 4 chiffres) au début si présent
        let cleaned = phoneStr.replace(/^\+\d{1,4}\s*/, '');
        // Retirer tous les espaces restants
        cleaned = cleaned.replace(/\s+/g, '');
        
        // Vérifier qu'il reste au moins 4 chiffres (minimum pour un numéro valide)
        const digitsOnly = cleaned.replace(/\D/g, '');
        // Si après nettoyage il reste au moins 4 chiffres, c'est valide
        // Sinon, si le numéro original contient au moins 6 caractères (incluant préfixe), c'est probablement valide
        return digitsOnly.length >= 4 || phoneStr.length >= 6;
      };
      
      // Validation personnalisée : vérifier que tous les champs obligatoires sont remplis
      if (!this.clientData) {
        console.log('❌ clientData est null ou undefined');
        return false;
      }
      
      let allFieldsValid = true;
      const invalidFields = [];
      
      // Vérifier les champs communs obligatoires
      if (!this.clientData.nom || (typeof this.clientData.nom === 'string' && this.clientData.nom.trim() === '')) {
        allFieldsValid = false;
        invalidFields.push('nom');
      }
      if (!this.clientData.prenom || (typeof this.clientData.prenom === 'string' && this.clientData.prenom.trim() === '')) {
        allFieldsValid = false;
        invalidFields.push('prenom');
      }
      if (!this.clientData.email || (typeof this.clientData.email === 'string' && this.clientData.email.trim() === '')) {
        allFieldsValid = false;
        invalidFields.push('email');
      }
      if (!this.clientData.rue || (typeof this.clientData.rue === 'string' && this.clientData.rue.trim() === '')) {
        allFieldsValid = false;
        invalidFields.push('rue');
      }
      if (!this.clientData.cp || (this.clientData.cp && this.clientData.cp.toString().trim() === '')) {
        allFieldsValid = false;
        invalidFields.push('cp');
      }
      if (!this.clientData.ville || (typeof this.clientData.ville === 'string' && this.clientData.ville.trim() === '')) {
        allFieldsValid = false;
        invalidFields.push('ville');
      }
      if (!this.clientData.zone) {
        allFieldsValid = false;
        invalidFields.push('zone');
      }
      if (!this.clientData.type_occupation) {
        allFieldsValid = false;
        invalidFields.push('type_occupation (Role)');
      }
      
      // Champs spécifiques aux particuliers
      if (!this.isProfessionel) {
        if (!this.clientData.civilite_1) {
          allFieldsValid = false;
          invalidFields.push('civilite_1');
        }
      }
      
      // Champs spécifiques aux professionnels
      if (this.isProfessionel) {
        if (!this.clientData.raison_sociale || (typeof this.clientData.raison_sociale === 'string' && this.clientData.raison_sociale.trim() === '')) {
          allFieldsValid = false;
          invalidFields.push('raison_sociale');
        }
        if (!this.clientData.siret || (this.clientData.siret && this.clientData.siret.toString().trim() === '')) {
          allFieldsValid = false;
          invalidFields.push('siret');
        }
      }
      
      // Vérifier les téléphones
      if (!this.isProfessionel) {
        const hasTelMobile = hasValidPhone(this.clientData.tel_mobile);
        const hasTelFixe = hasValidPhone(this.clientData.tel_fixe);
        if (!hasTelMobile && !hasTelFixe) {
          allFieldsValid = false;
          invalidFields.push('tel_mobile OU tel_fixe (au moins un obligatoire)');
        }
      }
      
      if (this.isProfessionel) {
        const hasTelMobilePro = hasValidPhone(this.clientData.tel_mobile_pro);
        const hasTelFixePro = hasValidPhone(this.clientData.tel_fixe_pro);
        if (!hasTelMobilePro && !hasTelFixePro) {
          allFieldsValid = false;
          invalidFields.push('tel_mobile_pro OU tel_fixe_pro (au moins un obligatoire)');
        }
      }
      
      // Si tous les champs sont valides selon notre logique personnalisée, retourner true
      if (allFieldsValid) {
        console.log('✅ Tous les champs obligatoires sont remplis');
        console.log('Validation réussie - retourne true');
        return true;
      }
      
      // Sinon, afficher les erreurs et retourner false
      console.log('❌ Champs obligatoires non remplis:', invalidFields);
      console.log('Type de client:', this.clientData.type);
      console.log('isProfessionel:', this.isProfessionel);
      console.log('allFieldsValid:', allFieldsValid);
      console.log('Valeurs des champs:', {
        nom: this.clientData.nom,
        prenom: this.clientData.prenom,
        email: this.clientData.email,
        rue: this.clientData.rue,
        cp: this.clientData.cp,
        ville: this.clientData.ville,
        zone: this.clientData.zone,
        type_occupation: this.clientData.type_occupation,
        raison_sociale: this.clientData.raison_sociale,
        siret: this.clientData.siret,
        tel_mobile_pro: this.clientData.tel_mobile_pro,
        tel_fixe_pro: this.clientData.tel_fixe_pro,
      });
      
      // Valider aussi avec Vuelidate pour afficher les erreurs visuelles
      await this.v$.$validate();
      
      console.log('Validation échouée - retourne false');
      return false;
    },
    customLabel(client) {
      return `${client.nom} ${client.prenom}`;
    },
    onKeyDown(event) {
      preventExceedingLength(event);
    },
    updateClientParent(field, value) {
      this.$emit("update-client", { ...this.clientData, [field]: value });
    },
    handleTypeChange(newType) {
      // Reset validation when type changes
      this.v$.$reset();
      // Update local clientData first to ensure consistency
      this.clientData.type = newType;
      // Immediately update parent with the new type (emits the complete updated clientData)
      this.updateClientParent('type', newType);
    },
    updateSignataireNom(event) {
      const value = event.target ? event.target.value : event;
      this.clientData.signataire_nom = value;
      this.updateClientParent('nom', value);
      this.updateClientParent('signataire_nom', value);
    },
    updateSignatairePrenom(event) {
      const value = event.target ? event.target.value : event;
      this.clientData.signataire_prenom = value;
      this.updateClientParent('prenom', value);
      this.updateClientParent('signataire_prenom', value);
    },

    onKeyDownFloat(event) {
      preventExceedingLengthFloat(event);
    },
    onPaste(event, fieldName) {
      handlePaste.call(this, event, fieldName);
    },
    validatePostalCode() {
      let value = this.clientData.cp;

      value = value.replace(/[^0-9]/g, "");

      this.clientData.cp = value;

      this.validationFeedback =
        value.length === 5 ? "" : "Please enter exactly 5 digits";
    },

    preventNumberInput(event) {
      const key = event.key;

      if (key >= "0" && key <= "9") {
        event.preventDefault();
      }
    },

    removeSpaces(phoneNumber) {
      return phoneNumber.replace(/\s+/g, "");
    },
    formatNumber(event) {
      if (event && event.number && event.country) {
        if (!this.isProfessionel) {
          this.clientData.tel_mobile = {
            phone_number: event.number,
            phone_iso_code: event.country.iso2,
          };
          this.updateClientParent('tel_mobile', this.clientData.tel_mobile);
        } else {
          this.clientData.tel_mobile_pro = {
            phone_number: event.number,
            phone_iso_code: event.country.iso2,
          };
          this.updateClientParent('tel_mobile_pro', this.clientData.tel_mobile_pro);
        }
        this.clientData.tel = {
          phone_number: event.number,
          phone_iso_code: event.country.iso2,
        };
        this.updateClientParent('tel', this.clientData.tel);
        this.resultValid = event.isValid;
      }
    },
    formatNumberE(event) {
      this.clientData.company_tel = {
        phone_number: event.number,
        phone_iso_code: event.country.iso2,
      };
      this.phoneValid = event.isValid;
    },
    formatNumberFixe(event) {
      if (event && event.number && event.country) {
        if (!this.isProfessionel) {
          this.clientData.tel_fixe = {
            phone_number: event.number,
            phone_iso_code: event.country.iso2,
          };
          this.updateClientParent('tel_fixe', this.clientData.tel_fixe);
        }
        this.resultValidFixe = event.isValid;
      }
    },
    formatMobileNumberPro(event) {
      if (this.isProfessionel) {
        this.clientData.tel_mobile_pro = {
          phone_number: event.number,
          phone_iso_code: event.country.iso2,
        };
        this.updateClientParent('tel_mobile_pro', this.clientData.tel_mobile_pro);
      }
      this.resultValidMobilePro = event.isValid;
    },
    formatFixedNumberPro(event) {
      if (this.isProfessionel) {
        this.clientData.tel_fixe_pro = {
          phone_number: event.number,
          phone_iso_code: event.country.iso2,
        };
        this.updateClientParent('tel_fixe_pro', this.clientData.tel_fixe_pro);
      }
      this.resultValidFixePro = event.isValid;
    },
    validateState(name) {
      const fieldValidation = this.v$.clientData[name];
      if (fieldValidation) {
        const { $dirty, $error } = fieldValidation;
        return $dirty ? !$error : null;
      }
      return null;
    },
    async addCLI() {
      // Valider le formulaire avant de soumettre
      const isFormValid = await this.v$.$validate();
      if (!isFormValid) {
        return;
      }
      
      if (this.selected) {
        const client = {
          ...this.clientData,
          revenu_avis_imposition: this.clientData.revenu_avis_imposition,
        };

        // Format phone numbers for particulier
        if (!this.isProfessionel) {
          // Format tel mobile (phone_number)
          if (this.clientData.tel_mobile && this.clientData.tel_mobile.phone_number) {
            let phoneNumber = this.clientData.tel_mobile.phone_number;
            const spaceIndex = phoneNumber.indexOf(" ");
            if (spaceIndex !== -1) {
              phoneNumber = phoneNumber.slice(spaceIndex + 1).split(" ").join("");
            } else {
              phoneNumber = phoneNumber.split(" ").join("");
            }
            client.phone_number = phoneNumber;
            client.tel = phoneNumber;
            client.phone_iso_code = this.clientData.tel_mobile.phone_iso_code;
          } else if (this.clientData.tel && this.clientData.tel.phone_number) {
            let phoneNumber = this.clientData.tel.phone_number;
            const spaceIndex = phoneNumber.indexOf(" ");
            if (spaceIndex !== -1) {
              phoneNumber = phoneNumber.slice(spaceIndex + 1).split(" ").join("");
            } else {
              phoneNumber = phoneNumber.split(" ").join("");
            }
            client.phone_number = phoneNumber;
            client.tel = phoneNumber;
            client.phone_iso_code = this.clientData.tel.phone_iso_code;
          }

          // Format tel fixe
          if (this.clientData.tel_fixe && this.clientData.tel_fixe.phone_number) {
            let telFixeNumber = this.clientData.tel_fixe.phone_number;
            const spaceIndex = telFixeNumber.indexOf(" ");
            if (spaceIndex !== -1) {
              telFixeNumber = telFixeNumber.slice(spaceIndex + 1).split(" ").join("");
            } else {
              telFixeNumber = telFixeNumber.split(" ").join("");
            }
            client.tel_fixe = telFixeNumber;
            client.tel_fixe_phone_number = telFixeNumber;
            client.tel_fixe_phone_iso_code = this.clientData.tel_fixe.phone_iso_code;
          }
        } else {
          // Format phone numbers for professionnel
          // Format tel mobile pro (phone_number)
          if (this.isProfessionel && this.clientData.tel_mobile_pro && this.clientData.tel_mobile_pro.phone_number) {
            let phoneNumber = this.clientData.tel_mobile_pro.phone_number;
            const spaceIndex = phoneNumber.indexOf(" ");
            if (spaceIndex !== -1) {
              phoneNumber = phoneNumber.slice(spaceIndex + 1).split(" ").join("");
            } else {
              phoneNumber = phoneNumber.split(" ").join("");
            }
            client.phone_number = phoneNumber;
            client.tel = phoneNumber;
            client.phone_iso_code = this.clientData.tel_mobile_pro.phone_iso_code;
          } else if (this.clientData.tel && this.clientData.tel.phone_number) {
            let phoneNumber = this.clientData.tel.phone_number;
            const spaceIndex = phoneNumber.indexOf(" ");
            if (spaceIndex !== -1) {
              phoneNumber = phoneNumber.slice(spaceIndex + 1).split(" ").join("");
            } else {
              phoneNumber = phoneNumber.split(" ").join("");
            }
            client.phone_number = phoneNumber;
            client.tel = phoneNumber;
            client.phone_iso_code = this.clientData.tel.phone_iso_code;
          }

          // Format tel fixe pro (company_tel)
          if (this.clientData.tel_fixe_pro && this.clientData.tel_fixe_pro.phone_number) {
            let companyTelNumber = this.clientData.tel_fixe_pro.phone_number;
            const spaceIndex = companyTelNumber.indexOf(" ");
            if (spaceIndex !== -1) {
              companyTelNumber = companyTelNumber.slice(spaceIndex + 1).split(" ").join("");
            } else {
              companyTelNumber = companyTelNumber.split(" ").join("");
            }
            client.company_tel = companyTelNumber;
            client.company_phone_number = companyTelNumber;
            client.company_phone_iso_code = this.clientData.tel_fixe_pro.phone_iso_code;
          } else if (this.clientData.company_tel && this.clientData.company_tel.phone_number) {
            let companyTelNumber = this.clientData.company_tel.phone_number;
            const spaceIndex = companyTelNumber.indexOf(" ");
            if (spaceIndex !== -1) {
              companyTelNumber = companyTelNumber.slice(spaceIndex + 1).split(" ").join("");
            } else {
              companyTelNumber = companyTelNumber.split(" ").join("");
            }
            client.company_tel = companyTelNumber;
            client.company_phone_number = companyTelNumber;
            client.company_phone_iso_code = this.clientData.company_tel.phone_iso_code;
          }
        }

        await this.edit_client({ data: client });

        const resclient = await this.client(this.clientData?.id);

        const loges = {
          client_id: this.clientData.id,
          adresse: this.logementValue.adresse,
          type: this.logementValue.type,
          proprietaire_occupant: this.logementValue.proprietaire_occupant,
          residence_principale_proprietaire:
            this.logementValue.residence_principale_proprietaire,
          equipement_deposee: this.logementValue.equipement_deposee,
          type_energie_equipement_deposee:
            this.logementValue.type_energie_equipement_deposee,
          periode_de_construction: this.logementValue.periode_de_construction,
          surface: this.logementValue.surface,
          parcelle_cadastrale: this.logementValue.parcelle_cadastrale,
          type_chauffage: this.logementValue.type_chauffage,
        };
        let res;
        // if(this.idLogementData &&this.clientData?.id!= this.getdevisMonoFiche.data.devis.client.id){

        // }
        if (!this.idLogementData) {
          res = await this.storeLogement(loges);
          this.getdevisMonoFiche.data.devis.logement_id = res.data.id;
          this.getdevisMonoFiche.data.devis.logement = {
            id: res.data.id,
          };
        }
        if (this.logementValue?.id) {
          this.getdevisMonoFiche.data.devis.logement_id =
            this.logementValue?.id;
          this.getdevisMonoFiche.data.devis.logement = {
            id: this.logementValue?.id,
            adresse: this.logementValue?.adresse,
            type: this.logementValue?.type,
            proprietaire_occupant: this.logementValue?.proprietaire_occupant,
            residence_principale_proprietaire:
              this.logementValue?.residence_principale_proprietaire,
            equipement_deposee: this.logementValue?.equipement_deposee,
            type_energie_equipement_deposee:
              this.logementValue?.type_energie_equipement_deposee,
            periode_de_construction:
              this.logementValue?.periode_de_construction,
            surface: this.logementValue?.surface,
            parcelle_cadastrale: this.logementValue?.parcelle_cadastrale,
            type_chauffage: this.logementValue?.type_chauffage,
          };
        }

        const menage = {
          client_id: this.clientData.id,
          revenu: this.menageValue.revenu,
          personnes: this.menageValue.personnes,
          commune: this.menageValue.commune,
        };
        let resMenage = resclient.data.menage;
        if (!resclient.data.menage) {
          resMenage = await this.storeMenage(menage);
        }
        if (
          this.getdevisMonoFiche &&
          this.getdevisMonoFiche.data &&
          this.getdevisMonoFiche.data.devis
        ) {
          // this.getdevisMonoFiche.data.devis.logement_id = res.data.id;

          this.getdevisMonoFiche.data.devis.client_id = this.clientData.id;
        }

        this.getdevisMonoFiche.data.devis.client = {
          id: this.clientData.id,
          company_phone_iso_code: client?.company_tel?.phone_iso_code,
          precarite: this.clientData?.precarite,
          pays: this.clientData?.pays,
          nom: this.clientData?.nom,
          prenom: this.clientData?.prenom,
          rue: this.clientData?.rue,
          zone: this.clientData?.zone,
          type: this.clientData?.type,
          ville: this.clientData?.ville,
          phone: resclient?.data.phone,
          company_phone: resclient?.data.company_phone,
          cp: this.clientData?.cp,
          email: this.clientData?.email,
          company: this.clientData?.company,
          
          SWIFT_BIC: this.clientData?.SWIFT_BIC,
          naf: this.clientData?.naf,
          ape: this.clientData?.ape,
          forme_juridique: this.client?.forme_juridique,
          revenu_avis_imposition: this.clientData?.revenu_avis_imposition,
          IBAN: this.clientData?.IBAN,
          titulaire_compte: this.clientData?.titulaire_compte,
          poste: this.clientData?.poste,
          commentaire: this.clientData?.commentaire,
          company_tel: resclient.company_tel,
          logements: this.clientData?.logements,
          menage: {
            id: resMenage.id,
          },
        };

        this.setDevisMonoFiche(this.getdevisMonoFiche);
        return { logement: res, client: this.clientData };
      } else {
        if (this.clientAdd) {
          const data = {
            ...this.clientData,
            pays: this.clientData.pays.iso_code,
          };
          
          // Supprimer les objets de téléphone avant de les reformater
          delete data.tel_mobile;
          delete data.tel_fixe;
          delete data.tel_mobile_pro;
          delete data.tel_fixe_pro;
          delete data.tel;
          delete data.company_tel;
          delete data.phone;
          delete data.company_phone;

          // Format phone numbers for particulier
          if (!this.isProfessionel) {
            // Format tel mobile (phone_number)
            if (this.clientData.tel_mobile && this.clientData.tel_mobile.phone_number) {
              let phoneNumber = this.clientData.tel_mobile.phone_number;
              const spaceIndex = phoneNumber.indexOf(" ");
              if (spaceIndex !== -1) {
                phoneNumber = phoneNumber.slice(spaceIndex + 1).split(" ").join("");
              } else {
                phoneNumber = phoneNumber.split(" ").join("");
              }
              data.phone_number = phoneNumber;
              data.tel = phoneNumber;
              data.phone_iso_code = this.clientData.tel_mobile.phone_iso_code;
            } else if (this.clientData.tel && this.clientData.tel.phone_number) {
              let phoneNumber = this.clientData.tel.phone_number;
              const spaceIndex = phoneNumber.indexOf(" ");
              if (spaceIndex !== -1) {
                phoneNumber = phoneNumber.slice(spaceIndex + 1).split(" ").join("");
              } else {
                phoneNumber = phoneNumber.split(" ").join("");
              }
              data.phone_number = phoneNumber;
              data.tel = phoneNumber;
              data.phone_iso_code = this.clientData.tel.phone_iso_code;
            }

            // Format tel fixe
            if (this.clientData.tel_fixe && this.clientData.tel_fixe.phone_number) {
              let telFixeNumber = this.clientData.tel_fixe.phone_number;
              
              // Retirer le préfixe du pays et les espaces
              // Si le numéro contient un espace, prendre la partie après le premier espace
              const spaceIndex = telFixeNumber.indexOf(" ");
              if (spaceIndex !== -1) {
                telFixeNumber = telFixeNumber.slice(spaceIndex + 1).split(" ").join("");
              } else {
                // Si le numéro commence par +, retirer le préfixe
                if (telFixeNumber.startsWith("+")) {
                  telFixeNumber = telFixeNumber.replace(/^\+\d{1,4}\s*/, "");
                }
                // Retirer tous les espaces
                telFixeNumber = telFixeNumber.split(" ").join("");
              }
              
              // S'assurer que c'est une string numérique
              telFixeNumber = telFixeNumber.replace(/\D/g, '');
              
              data.tel_fixe = telFixeNumber;
              data.tel_fixe_phone_number = telFixeNumber;
              data.tel_fixe_phone_iso_code = this.clientData.tel_fixe.phone_iso_code;
            }
          } else {
            // Format phone numbers for professionnel
            // Format tel mobile pro (phone_number)
            if (this.clientData.tel_mobile_pro && this.clientData.tel_mobile_pro.phone_number) {
              let phoneNumber = this.clientData.tel_mobile_pro.phone_number;
              const spaceIndex = phoneNumber.indexOf(" ");
              if (spaceIndex !== -1) {
                phoneNumber = phoneNumber.slice(spaceIndex + 1).split(" ").join("");
              } else {
                phoneNumber = phoneNumber.split(" ").join("");
              }
              data.phone_number = phoneNumber;
              data.tel = phoneNumber;
              data.phone_iso_code = this.clientData.tel_mobile_pro.phone_iso_code;
            } else if (this.clientData.tel && this.clientData.tel.phone_number) {
              let phoneNumber = this.clientData.tel.phone_number;
              const spaceIndex = phoneNumber.indexOf(" ");
              if (spaceIndex !== -1) {
                phoneNumber = phoneNumber.slice(spaceIndex + 1).split(" ").join("");
              } else {
                phoneNumber = phoneNumber.split(" ").join("");
              }
              data.phone_number = phoneNumber;
              data.tel = phoneNumber;
              data.phone_iso_code = this.clientData.tel.phone_iso_code;
            }

            // Format tel fixe pro (company_tel)
            if (this.clientData.tel_fixe_pro && this.clientData.tel_fixe_pro.phone_number) {
              let companyTelNumber = this.clientData.tel_fixe_pro.phone_number;
              const spaceIndex = companyTelNumber.indexOf(" ");
              if (spaceIndex !== -1) {
                companyTelNumber = companyTelNumber.slice(spaceIndex + 1).split(" ").join("");
              } else {
                companyTelNumber = companyTelNumber.split(" ").join("");
              }
              data.company_tel = companyTelNumber;
              data.company_phone_number = companyTelNumber;
              data.company_phone_iso_code = this.clientData.tel_fixe_pro.phone_iso_code;
            } else if (this.clientData.company_tel && this.clientData.company_tel.phone_number) {
              let companyTelNumber = this.clientData.company_tel.phone_number;
              const spaceIndex = companyTelNumber.indexOf(" ");
              if (spaceIndex !== -1) {
                companyTelNumber = companyTelNumber.slice(spaceIndex + 1).split(" ").join("");
              } else {
                companyTelNumber = companyTelNumber.split(" ").join("");
              }
              data.company_tel = companyTelNumber;
              data.company_phone_number = companyTelNumber;
              data.company_phone_iso_code = this.clientData.company_tel.phone_iso_code;
            }
          }

          data.entreprise_id = this.getdevisMonoFiche.data.devis.entreprise_id;

          data.precarite = this.clientData.precarite;
          if (this.clientData.type_occupation) {
            data.type_occupation = this.clientData.type_occupation;
          }
          
          // Poste (from fonction) for professionnel and particulier
          if (this.clientData.fonction) {
            data.poste = this.clientData.fonction;
          } else if (this.clientData.poste) {
            data.poste = this.clientData.poste;
          }

          this.erreurlist = {
            nom: null,
            prenom: null,
            email: null,
            rue: null,
            zone: null,
            cp: null,
            ville: null,
         
          };

          this.errorS = null;

          if (this.resultValid == false) return;
          if (this.clientData.company_tel && this.phoneValid == false) return;
          try {
            if (data.type === "type.particulier") {
              delete data.IBAN;
              delete data.SWIFT_BIC;
              delete data.forme_juridique;
              delete data.naf;
              delete data.ape;
              delete data.commentaire;
              delete data.company;
              delete data.company_email;
              delete data.company_phone;
              delete data.company_phone_iso_code;
              delete data.company_tel;
              // Ne pas supprimer poste si fonction existe (car fonction est mappé vers poste)
              if (!this.clientData.fonction) {
                delete data.poste;
              }
            }
            const response = await this.store_clients(data);
            console.log('response: ' , response)
            this.$emit("error-response", response.status_code);
            if (response.status_code === 422 || response.status_code === 409) {
              this.$refs.snackbar.showSnackbar("e-mail existe déjà");
              this.err = true;
             

              this.isLoading = false;
              return ;
            }

            this.errorS = null;
            const loges = {
              client_id: response.id,
              adresse: this.logementValue.adresse,
              type: this.logementValue.type,
              proprietaire_occupant: this.logementValue.proprietaire_occupant,
              residence_principale_proprietaire:
                this.logementValue.residence_principale_proprietaire,
              equipement_deposee: this.logementValue.equipement_deposee,
              type_energie_equipement_deposee:
                this.logementValue.type_energie_equipement_deposee,
              periode_de_construction:
                this.logementValue.periode_de_construction,
              surface: this.logementValue.surface,
              parcelle_cadastrale: this.logementValue.parcelle_cadastrale,
              type_chauffage: this.logementValue.type_chauffage,
            };

            const res = await this.storeLogement(loges);
            
            // Ménage uniquement pour les clients non professionnels
            let resmenage = null;
            const professionalTypes = [
              'type.professionnel',
              'type.particulier',
              'type.bailleur_sociale',
              'type.syndic_copropriete_professionnel',
              'type.entreprise',
              'type.etablissement',
              'type.collectivite_territoriale_mairie',
              'type.organisation_professionnelle',
              'type.syndic_copropriete_benevole'
            ];
            if (!professionalTypes.includes(data.type)) {
              const menage = {
                client_id: response.id,
                revenu: this.menageValue.revenu,
                personnes: this.menageValue.personnes,
                commune: this.menageValue.commune,
              };
              resmenage = await this.storeMenage(menage);
            }
            
            this.getdevisMonoFiche.data.devis.logement_id = res.data.id;
            this.getdevisMonoFiche.data.devis.client_id = response.id;
            this.getdevisMonoFiche.data.devis.logement = {
              id: res.data.id,
            };

            const clientObject = {
              id: response.id,
              precarite: this.clientData.precarite,
              pays: this.clientData.pays,
              nom: this.clientData.nom,
              prenom: this.clientData.prenom,
              rue: this.clientData.rue,
              zone: this.clientData.zone,
              type: this.clientData.type,
              ville: this.clientData.ville,
              tel: this.clientData.tel,
              phone: this.clientData.phone,
              company_phone: this.clientData.company_phone,
              cp: this.clientData.cp,
              email: this.clientData.email,
              company: this.clientData.company,
              SWIFT_BIC: this.clientData.SWIFT_BIC,
              forme_juridique: this.clientData.forme_juridique,
              naf: this.clientData.naf,
              ape: this.clientData.ape,
              revenu_avis_imposition: this.clientData.revenu_avis_imposition,
              IBAN: this.clientData.IBAN,
              titulaire_compte: this.clientData.titulaire_compte,
              poste: this.clientData.poste,
              commentaire: this.clientData.commentaire,
              company_tel: this.clientData.company_tel,
              logements: this.clientData.logements,
            };
            
            // Ajouter le ménage uniquement pour les clients particuliers
            if (resmenage) {
              clientObject.menage = {
                id: resmenage.id,
              };
            }
            
            this.getdevisMonoFiche.data.devis.client = clientObject;

            this.setDevisMonoFiche(this.getdevisMonoFiche);
            return { logement: res, client: response };
          } catch (err) {
            if (this.isObject(err)) {
              for (const [key, value] of Object.entries(err)) {
                if (!this.erreurlist[key]) {
                  this.erreurlist[key] = value;
                }
              }
            } else {
              this.errorS = err;
            }
          }
        }
      }
    },
    cleanPhoneNumber(phoneNumber) {
      return phoneNumber.replace(/^\+\d+\s*/, "");
    },
    isObject(obj) {
      return Object.prototype.toString.call(obj) === "[object Object]";
    },

    selectclient(client) {
      console.log('=== CLIENT SÉLECTIONNÉ (selectclient) ===', client);
      this.clientData = { ...client };
      this.getdevisMonoFiche.data.devis.client = { ...client };
      console.log('=== CLIENT DATA APRÈS COPIE ===', this.clientData);
      this.selected = true;
      this.disabled = true;
    },
    handlePosteInput(value) {
      // Synchroniser fonction et poste
      this.clientData.fonction = value;
      this.clientData.poste = value;
      this.updateClientParent('fonction', value);
      this.updateClientParent('poste', value);
    },
    handleFonctionInput(value) {
      // Synchroniser fonction et poste pour les clients professionnels
      this.clientData.fonction = value;
      if (this.isProfessionel) {
        this.clientData.poste = value;
        this.updateClientParent('poste', value);
      }
      this.updateClientParent('fonction', value);
    },
    formatPhoneNumbersOnMount() {
      if (!this.clientData) return;
      
      // Pour les clients particuliers - formater tel_fixe
      if (!this.isProfessionel) {
        // Formater tel_fixe si ce n'est pas déjà un objet
        if (this.clientData.tel_fixe) {
          if (typeof this.clientData.tel_fixe === 'string') {
            this.$set(this.clientData, 'tel_fixe', {
              phone_number: this.clientData.tel_fixe,
              phone_iso_code: 'FR',
              formated_phone: null,
            });
            this.updateClientParent('tel_fixe', this.clientData.tel_fixe);
          } else if (this.clientData.tel_fixe && !this.clientData.tel_fixe.phone_number) {
            // Si c'est un objet mais sans phone_number
            this.$set(this.clientData, 'tel_fixe', {
              phone_number: this.clientData.tel_fixe || null,
              phone_iso_code: this.clientData.tel_fixe?.phone_iso_code || 'FR',
              formated_phone: null,
            });
            this.updateClientParent('tel_fixe', this.clientData.tel_fixe);
          }
        }
        
        // Formater tel_mobile si nécessaire
        if (this.clientData.phone && !this.clientData.tel_mobile) {
          const phoneNumber = this.clientData.phone.phone_number || null;
          const isoCode = this.clientData.phone.iso_code || 'FR';
          const formatedPhone = this.clientData.phone.formated_phone || null;
          
          this.$set(this.clientData, 'tel_mobile', {
            phone_number: phoneNumber,
            phone_iso_code: isoCode,
            iso_code: isoCode,
            formated_phone: formatedPhone,
          });
          this.updateClientParent('tel_mobile', this.clientData.tel_mobile);
        }
      }
      
      // Pour les clients professionnels - formater tel_mobile_pro et tel_fixe_pro
      if (this.isProfessionel) {
        // Formater tel_mobile_pro si nécessaire
        if (this.clientData.phone && !this.clientData.tel_mobile_pro) {
          const phoneNumber = this.clientData.phone.phone_number || null;
          const isoCode = this.clientData.phone.iso_code || 
                         this.clientData.phone.country_id?.iso_code || 
                         'FR';
          const formatedPhone = this.clientData.phone.formated_phone || null;
          
          if (phoneNumber) {
            this.$set(this.clientData, 'tel_mobile_pro', {
              phone_number: phoneNumber,
              phone_iso_code: isoCode,
              iso_code: isoCode,
              formated_phone: formatedPhone,
            });
            this.updateClientParent('tel_mobile_pro', this.clientData.tel_mobile_pro);
          }
        }
        
        // Formater tel_fixe_pro si nécessaire
        if (this.clientData.company_phone && !this.clientData.tel_fixe_pro) {
          const companyPhoneNumber = this.clientData.company_phone.phone_number || null;
          const companyIsoCode = this.clientData.company_phone.iso_code || 
                                this.clientData.company_phone.country_id?.iso_code || 
                                'FR';
          const companyFormatedPhone = this.clientData.company_phone.formated_phone || null;
          
          if (companyPhoneNumber) {
            this.$set(this.clientData, 'tel_fixe_pro', {
              phone_number: companyPhoneNumber,
              phone_iso_code: companyIsoCode,
              formated_phone: companyFormatedPhone,
            });
            this.updateClientParent('tel_fixe_pro', this.clientData.tel_fixe_pro);
          }
        }
      }
    },
  },
};
</script>
